import req from 'shared/req';

export const sendReferrals = (referrals) =>
  req({
    url: '/students/create-referrals',
    method: 'post',
    data: {
      referrals,
      referralType: 'onboarding-cta',
    },
  });

export const dismissReferralsCta = () =>
  req({
    url: '/students/dismiss-referrals-cta',
    method: 'post',
  });
